module.exports = __webpack_public_path__ + "img/ic-facebook.b0a419d2.svg";